import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { ShieldCheck, ArrowLeft } from "lucide-react";import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { useLanguage } from "@/context/LanguageContext";

const GoogleIcon = () => (
  <svg viewBox="0 0 24 24" className="h-5 w-5" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" />
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84A11 11 0 0 0 12 23z" />
    <path fill="#FBBC05" d="M5.84 14.1a6.6 6.6 0 0 1 0-4.2V7.06H2.18a11 11 0 0 0 0 9.88l3.66-2.84z" />
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1A11 11 0 0 0 2.18 7.06l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z" />
  </svg>
);

export default function AdminLogin() {
  const { loginWithGoogle } = useAuth();
  const { t, lang } = useLanguage();
  const location = useLocation();
  const es = lang === "es";
  const [error, setError] = useState("");

  useEffect(() => {
    if (location.state?.error) setError(location.state.error);
  }, [location.state]);

  return (
    <div className="min-h-screen grid place-items-center bg-primary text-primary-foreground px-5 relative overflow-hidden noise" data-testid="admin-login-page">
      <div className="w-full max-w-sm relative text-center">
        <div className="h-14 w-14 mx-auto border border-gold/40 grid place-items-center mb-6">
          <ShieldCheck className="h-6 w-6 text-gold" />
        </div>
        <span className="font-serif font-bold text-3xl tracking-[0.12em]">M&amp;A Jewelry</span>
        <p className="overline text-gold mt-3">{t("Admin Console")}</p>
        <p className="text-sm text-primary-foreground/60 mt-6 leading-relaxed">
          {es
            ? "Acceso exclusivo para administradores autorizados. Inicia sesión con tu cuenta de Google."
            : "Exclusive access for authorized administrators. Sign in with your Google account."}
        </p>

        {error && (
          <div className="text-sm text-red-300 border border-red-400/30 bg-red-500/10 px-4 py-3 mt-6" data-testid="admin-login-error">
            {error}
          </div>
        )}

        <Button
          onClick={loginWithGoogle}
          className="w-full rounded-none h-12 mt-8 bg-white text-neutral-800 hover:bg-white/90"
          data-testid="admin-google-login-btn"
        >
          <span className="mr-3"><GoogleIcon /></span>
          {es ? "Continuar con Google" : "Continue with Google"}
        </Button>

        <p className="text-[11px] text-primary-foreground/40 mt-6">
          {es ? "Solo cuentas autorizadas pueden ingresar." : "Only authorized accounts can sign in."}
        </p>

        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-primary-foreground/60 hover:text-gold transition-colors mt-8"
          data-testid="admin-login-back-btn"
        >
          <ArrowLeft className="h-4 w-4" /> {es ? "Volver" : "Back"}
        </Link>
      </div>
    </div>
  );
}
